"use strict";exports.BASE_PIXELS=16,exports.toRem=function(t,r=16){return parseInt(String(t),10)/r+"rem"};
